export var PREDICATE_OPERATOR_AFTER = 'after';
export var PREDICATE_OPERATOR_BEFORE = 'before';
export var PREDICATE_OPERATOR_BY = 'by';
export var PREDICATE_OPERATOR_DURING = 'during';
export var PREDICATE_OPERATOR_FROM = 'from';
export var PREDICATE_OPERATOR_ON = 'on';
export var PREDICATE_OPERATOR_TO = 'to';
export var PREDICATE_OPERATORS = [PREDICATE_OPERATOR_AFTER, PREDICATE_OPERATOR_BEFORE, PREDICATE_OPERATOR_BY, PREDICATE_OPERATOR_DURING, PREDICATE_OPERATOR_FROM, PREDICATE_OPERATOR_ON, PREDICATE_OPERATOR_TO];